import axios from '../utils/axios';

export default function fetchLearningSubscription(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/learning-subscription', { params })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            })
    )
}